import React from 'react'
import './styles.css'

const SpinnerSVG = () => {
  return (
    <svg viewBox="0 0 512 512" className="spinner">
      <path
        fill="white"
        d="M304,48c0,26.5-21.5,48-48,48s-48-21.5-48-48s21.5-48,48-48S304,21.5,304,48z M256,416c-26.5,0-48,21.5-48,48s21.5,48,48,48
	s48-21.5,48-48S282.5,416,256,416z M464,208c-26.5,0-48,21.5-48,48s21.5,48,48,48s48-21.5,48-48S490.5,208,464,208z M96,256
	c0-26.5-21.5-48-48-48S0,229.5,0,256s21.5,48,48,48S96,282.5,96,256z M108.9,355.1c-26.5,0-48,21.5-48,48s21.5,48,48,48
	s48-21.5,48-48C156.9,376.6,135.4,355.1,108.9,355.1z M403.1,355.1c-26.5,0-48,21.5-48,48s21.5,48,48,48s48-21.5,48-48
	C451.1,376.6,429.6,355.1,403.1,355.1z M108.9,60.9c-26.5,0-48,21.5-48,48s21.5,48,48,48s48-21.5,48-48S135.4,60.9,108.9,60.9z M403.1,60.9c26.5,0,48,21.5,48,48s-21.5,48-48,48s-48-21.5-48-48S376.6,60.9,403.1,60.9z"
      />
    </svg>
  )
}

export default SpinnerSVG



// WEBPACK FOOTER //
// ./src/assets/spinner/index.js